import { combineReducers, createStore as createStore$1, applyMiddleware, compose } from 'redux';
import { createAction } from 'typesafe-actions';
import { getDefaultEntities, normalize } from '@hyperion-framework/parser';

const ADD_MAPPING = '@hyperion/ADD_MAPPING';
const ADD_MAPPINGS = '@hyperion/ADD_MAPPINGS';
const addMapping = createAction(ADD_MAPPING)();
const addMappings = createAction(ADD_MAPPINGS)();
const mappingActions = { addMapping, addMappings };
const mappingReducer = (state = {}, action) => {
    switch (action.type) {
        case ADD_MAPPING:
            return Object.assign(Object.assign({}, state), { [action.payload.id]: action.payload.type });
        case ADD_MAPPINGS:
            return Object.assign(Object.assign({}, state), action.payload.mapping);
        default:
            return state;
    }
};

const IMPORT_ENTITIES = '@hyperion/IMPORT_ENTITIES';
const MODIFY_ENTITY_FIELD = '@hyperion/MODIFY_ENTITY_FIELD';
const importEntities = createAction(IMPORT_ENTITIES)();
const modifyEntityField = createAction(MODIFY_ENTITY_FIELD)();
const entityActions = { importEntities, modifyEntityField };
const entityReducer = (state = getDefaultEntities(), action) => {
    if (action.type === MODIFY_ENTITY_FIELD) {
        if (!state[action.payload.type] || !state[action.payload.type][action.payload.id]) {
            return state;
        }
        const entity = state[action.payload.type][action.payload.id];
        if (typeof entity === 'string') {
            return state;
        }
        return Object.assign(Object.assign({}, state), { [action.payload.type]: Object.assign(Object.assign({}, state[action.payload.type]), { [action.payload.id]: Object.assign(Object.assign({}, entity), { [action.payload.key]: action.payload.value }) }) });
    }
    if (action.type === IMPORT_ENTITIES) {
        return {
            Collection: Object.assign(Object.assign({}, state.Collection), action.payload.entities.Collection),
            Manifest: Object.assign(Object.assign({}, state.Manifest), action.payload.entities.Manifest),
            Canvas: Object.assign(Object.assign({}, state.Canvas), action.payload.entities.Canvas),
            AnnotationPage: Object.assign(Object.assign({}, state.AnnotationPage), action.payload.entities.AnnotationPage),
            AnnotationCollection: Object.assign(Object.assign({}, state.AnnotationCollection), action.payload.entities.AnnotationCollection),
            Annotation: Object.assign(Object.assign({}, state.Annotation), action.payload.entities.Annotation),
            ContentResource: Object.assign(Object.assign({}, state.ContentResource), action.payload.entities.ContentResource),
            Range: Object.assign(Object.assign({}, state.Range), action.payload.entities.Range),
            Service: Object.assign(Object.assign({}, state.Service), action.payload.entities.Service),
            Selector: Object.assign(Object.assign({}, state.Selector), action.payload.entities.Selector),
        };
    }
    return state;
};

const REQUEST_RESOURCE = '@hyperion/REQUEST_RESOURCE';
const REQUEST_ERROR = '@hyperion/REQUEST_ERROR';
const REQUEST_MISMATCH = '@hyperion/REQUEST_MISMATCH';
const REQUEST_COMPLETE = '@hyperion/REQUEST_COMPLETE';
const REQUEST_OFFLINE_RESOURCE = '@hyperion/REQUEST_OFFLINE_RESOURCE';
const requestResource = createAction(REQUEST_RESOURCE)();
const requestError = createAction(REQUEST_ERROR)();
const requestMismatch = createAction(REQUEST_MISMATCH)();
const requestComplete = createAction(REQUEST_COMPLETE)();
const requestOfflineResource = createAction(REQUEST_OFFLINE_RESOURCE)();
const requestActions = {
    requestResource,
    requestError,
    requestMismatch,
    requestComplete,
    requestOfflineResource,
};
const requestReducer = (state = {}, action) => {
    switch (action.type) {
        case REQUEST_RESOURCE:
        case REQUEST_OFFLINE_RESOURCE:
            return Object.assign(Object.assign({}, state), { [action.payload.id]: {
                    requestUri: action.payload.id,
                    loadingState: 'RESOURCE_LOADING',
                    uriMismatch: false,
                    resourceUri: action.payload.id,
                } });
        case REQUEST_MISMATCH:
            return Object.assign(Object.assign({}, state), { [action.payload.requestId]: Object.assign(Object.assign({}, (state[action.payload.requestId] || {})), { uriMismatch: true, resourceUri: action.payload.actualId }), [action.payload.actualId]: {
                    requestUri: action.payload.requestId,
                    loadingState: state[action.payload.requestId].loadingState,
                    uriMismatch: true,
                    resourceUri: action.payload.actualId,
                } });
        case REQUEST_ERROR:
            return Object.assign(Object.assign({}, state), { [action.payload.id]: Object.assign(Object.assign({}, (state[action.payload.id] || {})), { loadingState: 'RESOURCE_ERROR', error: action.payload.message }) });
        case REQUEST_COMPLETE:
            return Object.assign(Object.assign({}, state), { [action.payload.id]: Object.assign(Object.assign({}, (state[action.payload.id] || {})), { loadingState: 'RESOURCE_READY', error: undefined }) });
    }
    return state;
};

function getMetaFromState(state, id, name, key) {
    if (!state[id] || !state[id][name] || !state[id][name][key]) {
        return undefined;
    }
    return state[id][name][key];
}
const SET_META_VALUE = '@hyperion/SET_META_VALUE';
const SET_META_VALUE_DYNAMIC = '@hyperion/SET_META_VALUE_DYNAMIC';
const UNSET_META_VALUE = '@hyperion/UNSET_META_VALUE';
const setMetaValue = createAction(SET_META_VALUE)();
const setMetaValueDynamic = createAction(SET_META_VALUE_DYNAMIC)();
const unsetMetaValue = createAction(UNSET_META_VALUE)();
const metaActions = {
    setMetaValue,
    setMetaValueDynamic,
    unsetMetaValue,
};
const metaReducer = (state = {}, action) => {
    const { id, updateValue, value, meta, key } = ((action && action.payload) || {});
    switch (action.type) {
        case SET_META_VALUE: {
            console.log('SET METADATA ACTION', action);
            return Object.assign(Object.assign({}, state), { [id]: Object.assign(Object.assign({}, (state[id] || {})), { [meta]: Object.assign(Object.assign({}, (state[id] ? state[id][meta] || {} : {})), { [key]: value }) }) });
        }
        case SET_META_VALUE_DYNAMIC: {
            return Object.assign(Object.assign({}, state), { [id]: Object.assign(Object.assign({}, (state[id] || {})), { [meta]: Object.assign(Object.assign({}, (state[id] ? state[id][meta] || {} : {})), { [key]: state[id] && state[id][meta] ? updateValue(state[id][meta][key]) : updateValue(undefined) }) }) });
        }
        case UNSET_META_VALUE: {
            if (state[id] && state[id][meta] && state[id][meta][key]) {
                return Object.assign(Object.assign({}, state), { [id]: Object.assign(Object.assign({}, (state[id] || {})), { [meta]: Object.assign(Object.assign({}, (state[id] ? state[id][meta] || {} : {})), { [key]: undefined }) }) });
            }
            return state;
        }
        default:
            return state;
    }
};

const reducers = combineReducers({
    mapping: mappingReducer,
    entities: entityReducer,
    requests: requestReducer,
    meta: metaReducer,
});
const composeEnhancers = typeof window !== 'undefined' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;
function createStore(customReducers = {}, extraMiddleware = [], defaultState = {}) {
    const store = createStore$1(combineReducers(Object.assign({ hyperion: reducers }, customReducers)), defaultState, composeEnhancers(applyMiddleware(...extraMiddleware)));
    return store;
}

const actionListFromResource = (id, response) => {
    const { entities, resource, mapping } = normalize(response);
    if (resource.id === undefined) {
        return [requestError({ id, message: 'ID is not defined in resource.' })];
    }
    const actions = [importEntities({ entities }), addMappings({ mapping })];
    if (resource.id !== id) {
        actions.push(addMapping({ id, type: resource.type }));
        actions.push(requestMismatch({ requestId: id, actualId: resource.id }));
    }
    actions.push(requestComplete({ id }));
    return actions;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function resolveIfExists(state, url) {
    const request = state.hyperion.requests[url];
    const resourceType = state.hyperion.mapping[url];
    if (!resourceType || !state.hyperion.entities[resourceType][request.resourceUri]) {
        return undefined;
    }
    return state.hyperion.entities[resourceType][request.resourceUri];
}

function createFetchHelper(store, fetcher, { waitTimeout = 30 } = {}) {
    return (url, options) => __awaiter(this, void 0, void 0, function* () {
        const state = store.getState();
        const request = state.hyperion.requests[url];
        if (request) {
            switch (request.loadingState) {
                case 'RESOURCE_ERROR':
                    break;
                case 'RESOURCE_LOADING': {
                    let cleanupSubscription;
                    try {
                        const resolvedEntity = yield Promise.race([
                            new Promise((resolve, reject) => {
                                cleanupSubscription = store.subscribe(() => {
                                    const latestState = store.getState();
                                    if (latestState.hyperion.requests[url].loadingState === 'RESOURCE_ERROR') {
                                        reject();
                                        return;
                                    }
                                    if (latestState.hyperion.requests[url].loadingState === 'RESOURCE_READY') {
                                        const maybeResolvedEntity = resolveIfExists(latestState, url);
                                        if (maybeResolvedEntity) {
                                            resolve(maybeResolvedEntity);
                                        }
                                        else {
                                            reject();
                                        }
                                    }
                                });
                            }),
                            new Promise((resolve, reject) => setTimeout(reject, waitTimeout * 60)),
                        ]);
                        if (cleanupSubscription)
                            cleanupSubscription();
                        if (resolvedEntity) {
                            return resolvedEntity;
                        }
                    }
                    catch (e) {
                        if (cleanupSubscription)
                            cleanupSubscription();
                        break;
                    }
                    break;
                }
                case 'RESOURCE_READY': {
                    const resolvedEntity = resolveIfExists(state, url);
                    if (resolvedEntity) {
                        return resolvedEntity;
                    }
                    break;
                }
            }
        }
        store.dispatch(requestResource({ id: url }));
        try {
            const resource = yield fetcher(url, options);
            const toDispatch = actionListFromResource(url, resource);
            for (const action of toDispatch) {
                store.dispatch(action);
            }
            return resolveIfExists(store.getState(), url);
        }
        catch (err) {
            store.dispatch(requestError({ id: url, message: err.toString() }));
            throw err;
        }
    });
}

function resolveList(state, items) {
    const returnItems = [];
    for (const ref of items) {
        if (state.hyperion.entities[ref.type] && state.hyperion.entities[ref.type][ref.id]) {
            returnItems.push(state.hyperion.entities[ref.type][ref.id]);
        }
    }
    return returnItems;
}

export { actionListFromResource, createFetchHelper, createStore, entityActions, getMetaFromState, mappingActions, metaActions, requestActions, resolveIfExists, resolveList };
//# sourceMappingURL=index.es.js.map
